import axios from "axios";

import { GET_PURCHASE_COIN_HISTORY, GET_VIP_PLAN_HISTORY } from "./types";
import { apiInstanceFetch } from "../../util/api";

export const getPurchaseCoinHistory = () => (dispatch) => {
  apiInstanceFetch
    .get("/history/admin/history")
    .then((res) => {
      dispatch({ type: GET_PURCHASE_COIN_HISTORY, payload: res.data });
    })
    .catch((error) => console.log(error));
};

export const getVipPlanHistory = (start,limit) => (dispatch) => {
  apiInstanceFetch
    .get(`/VipHistory?start=${start}&limit=${limit}`)
    .then((res) => {  
      dispatch({ type: GET_VIP_PLAN_HISTORY, payload: res.data });
    })
    .catch((error) => console.log(error));
};
